import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/agents")({
	beforeLoad: () => {
		throw redirect({ to: "/dashboard", replace: true });
	},
	component: () => null,
});
